export default __webpack_public_path__ + "static/media/base.c4da96e8.png";